<template>
  <div id="app" class="main-wrapper dd-hidden" :class="{ 'active-stream': stream, 'hide-status-bar': !isStatusbar, 'new-design': newDesignEnabled }">
    <Header v-if="!hideHeader"/>
    <CryptoPayment v-if="$store.getters.cryptocurrencyPaymentMode && !newDesignEnabled && !checkoutFrontendEnabled"/>
    <router-view></router-view>
    <div class="footer-logout" v-if="$store.getters.authenticated && !newDesignEnabled && !checkoutFrontendEnabled">
      <div class="wrapper">
        <a href="/logout" class="orange-link" v-html="$t('logout')"></a>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header";
import CryptoPayment from "@/components/CryptoPayment";
import {logWarn} from '@/helpers';

export default {
  components: {
    Header,
    CryptoPayment,
  },
  mounted() {
    // Reveal the root only after store.init has applied server config (to avoid old-design flicker)
    const reveal = () => {
      try {
        if (this.$el && this.$el.classList) {
          this.$el.classList.remove('dd-hidden');
        }
      } catch (e) {
        logWarn('Failed to reveal app root element', e);
      }
    };
    const onReady = () => { document.removeEventListener('dd:ready', onReady); reveal(); };
    document.addEventListener('dd:ready', onReady);
    // Safety fallback in case event is missed (e.g., cached hydration)
    if (window.__DD_READY__) {
      reveal();
      document.removeEventListener('dd:ready', onReady);
    }
  },
  computed: {
    newDesignEnabled() {
      // from store or initial config
      return this.$store.getters.newDesignEnabled || !!window.appConfig?.new_design_enabled;
    },
    checkoutFrontendEnabled() {
      return this.$store.getters.checkoutFrontendEnabled || window.appConfig?.frontend_mode === 'checkout';
    },
    hideHeader() {
      return this.$route.matched && this.$route.matched.some(r => r.meta && r.meta.hideHeader);
    },
    stream() {
      return this.$store.getters.stream;
    },
    isStatusbar() {
      return !(
        this.$route.name === "stream-no-effect-paid-mode" ||
        this.$route.name === "stream-no-effect"
      );
    }
  }
};
</script>
<style lang="scss" src="@/assets/css/index.scss" />
<style>
.dd-hidden { display: none; }
</style>
